module.exports = __webpack_public_path__ + "static/media/cost_effective_symbol44427027_M.0a7833c5.jpg";